import React, { Component } from 'react'
import { observer } from 'mobx-react'

import InvoiceDetails from './invoicedetails'

@observer(['invoices'])
export default class CreateInvoice extends Component {
  constructor(props) {
    super(props)

  }

  saveInvoice(invoiceInfo, callback) {
    this.props.invoices.saveInvoice(invoiceInfo, (invoice) => {
      if (callback != null) {
        callback(invoice)
      }
    })
  }

  render() {
    return (
      <div>
        <InvoiceDetails type={ 'new' } companyId={ this.props.params.companyId } saveInvoice={ this.saveInvoice.bind(this) } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/company/createinvoice.js